import { forwardRef } from 'react';
import { useTranslation } from 'react-i18next';

import { MpBlock } from 'shared/ui/MpBlock';
import { MpParagraph } from 'shared/ui/MpParagraph';
import { MpTitle } from 'shared/ui/MpTitle';
import { ApplicationWithDetails } from '../../types';
import { ApplicationInfo } from '../ApplicationInfo/ApplicationInfo';
import { ArrowLeft } from '../Arrows/ArrowLeft';
import { ArrowRight } from '../Arrows/ArrowRight';
import { CarouselItemStyled, CarouselStyled } from './ApplicationDescription.styles';

import './ApplicationDescription.css';

type ApplicationDescriptionProps = {
	application: ApplicationWithDetails;
	downloads: number | null;
};

export const ApplicationDescription = forwardRef<HTMLElement, ApplicationDescriptionProps>(
	({ application, downloads }, ref) => {
		const { sliders, descriptionLong, descriptionHTML, price, type, languages, plans } = application;

		const { t } = useTranslation();

		return (
			<section style={{ marginTop: `16px` }}>
				<CarouselStyled autoplay arrows prevArrow={<ArrowLeft />} nextArrow={<ArrowRight />}>
					{sliders.map(n => (
						<CarouselItemStyled key={n}>
							<img alt='carousel item' style={{ height: `100%` }} src={n} />
						</CarouselItemStyled>
					))}
				</CarouselStyled>
				<ApplicationInfo
					price={price}
					plans={!!plans}
					type={type}
					languages={languages}
					downloads={downloads}
				/>
				<MpBlock ref={ref} style={{ marginBottom: `48px` }}>
					<MpTitle level={2}>{t(`Marketplace_About_App`)}</MpTitle>
					{descriptionLong && <MpParagraph>{descriptionLong}</MpParagraph>}
					{descriptionHTML && descriptionHTML({})}
				</MpBlock>
			</section>
		);
	},
);
